import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import { useAuth } from './AuthContext';

function Header(props) {
    const location = useLocation();
    const navigate = useNavigate();

    //changing based on login 
    const { isLoggedIn, logout } = useAuth();

    //made it more readable, these are the routes that will have the appropriate links in the header
    const headerPaths = {
        "/bm": "M",
        "/setup": "M",
        "/management": "M",
        "/filemanagement": "M",
        // "/studenthome":    "M",
        "/complete": "S",
        "/studentinfo": "S"
    };

    const logoutDebug = () => {
        // console.log("logged out");
        logout();
        localStorage.removeItem('authToken');
        navigate('/bm');
    }

    return (
        <div className='Header'>
            <div className="left-placeholder"></div>
            <Link to="/" className="header-logo">
                <img src={"MarshallLogo.png"} alt="Marshall Logo" height={75} />
            </Link>
            {headerPaths[location.pathname] === "M" ? (
                <div className="header-links">
                    {!isLoggedIn && <Link to="/" className="header-link">Go Back</Link>}
                    {!isLoggedIn && <Link to="/bm" className="header-link">Login</Link>}
                    {isLoggedIn && <Link to="/setup" className="header-link">Setup</Link>}
                    {isLoggedIn && <Link to="/management" className="header-link">Ongoing</Link>}
                    {isLoggedIn && <Link to="/filemanagement" className="header-link">Terminated</Link>}
                    {isLoggedIn && (<div onClick={logoutDebug} className="text-button">Logout</div>)}
                </div>
            ) : (
                <div>

                </div>
            )}

        </div>
    );
}

export default Header;